<div class="create-transaction-scheduler">
  <div class="scheduler-toggle-button-wrapper">
    <button class="scheduler-toggle-button checked" [disabled]="true">
      <rkt-icon name="checkbox-on"></rkt-icon>
      Schedule a time
    </button>
  </div>

  <div class="create-transaction-scheduler-form-container">
    <form class="create-transaction-scheduler-form" [formGroup]="schedulerNameForm">
      <rkt-form
        [form]="schedulerNameForm"
        [fields]="schedulerNameFormFields"
        [model]="schedulerFormModel"
        (modelChange)="onModelChange()"
      ></rkt-form>
    </form>

    <div class="create-transaction-scheduler-form">
      <form [formGroup]="schedulerForm">
        <rkt-form
          [form]="schedulerForm"
          [fields]="schedulerFormFields"
          [model]="schedulerFormModel"
          (modelChange)="onModelChange()"
        ></rkt-form>
      </form>

      @if (startTimeError) {
        <div class="start-time-error">{{ startTimeError }}</div>
      }

      @if (schedulerFormModel.alreadySentCount; as alreadySentCount) {
        <div class="create-transaction-scheduler-sent-count">
          Already sent {{ alreadySentCount }} {{ alreadySentCount > 1 ? 'transactions' : 'transaction' }}
        </div>
      }
    </div>
  </div>
</div>
